import React, { Component } from "react";
import ReactTable from "react-table";
import { Configurations } from '../../Utils/Configurations';
import moment from 'moment';
import axios from 'axios';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';


class NotificationsList extends Component {
    constructor(props) {
        super(props);

        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.carregaListaAvisos = this.carregaListaAvisos.bind(this);
        this.selecionaAviso = this.selecionaAviso.bind(this);
        this.refreshTableAvisos = this.refreshTableAvisos.bind(this);


        this.state = {
            hasError: false,
            errorMessage: '',
            listaAvisos: [],
            paginasAvisos: 1,
            limite: 15,
            pagina: 0,
            


        }

        this.Configurations = new Configurations();

        this.columns = [
            {
                Header: 'id',
                accessor: 'idAviso',
                className: 'text-center pointer',
                width: 100
            },
            {
                Header: 'Data de envio',
                accessor: 'dtAviso',
                className: 'text-center pointer',
                width: 250,
                Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YY")}</span> : <span>erro</span>)
            },
            {
                Header: 'Tipo de disparo',
                className: 'text-center pointer',
                width: 250,
                Cell: row => (<span>{row.original.listaTipoDisparo[0].nome}</span>)

            },
            {
                Header: 'Tipo de aviso',
                className: 'text-center pointer',
                width: 250,
                Cell: row => (<span>{row.original.listaTipoAviso[0].nome}</span>)

            },
            {
                Header: 'Quantidade de itens',
                accessor: 'qtdDisparos',
                className: 'text-center pointer',




            },
        ]
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: "" })
    }

    refreshTableAvisos(o) {
        this.carregaListaAvisos(o);
    }


    carregaListaAvisos(o) {
        this.setState({ isLoadingAvisos: true })
        let pagina, tamanhoPagina;
        if (o === undefined) {
            pagina = 0;
            tamanhoPagina = 10;
        }
        else if (!o.pageSize) {
            tamanhoPagina = this.state.limite;
        } else if (!(o.page + 1)) {
            pagina = this.state.pagina;
        } else {
            tamanhoPagina = o.pageSize;
            pagina = o.page;
            this.setState({
                pagina: pagina,
                limite: tamanhoPagina
            })
        }
        const _notifications = axios.get(this.Configurations.apiBasePath + `/aviso-vencimento/avisos?page=${pagina + 1}&pageSize=${tamanhoPagina}`);
        _notifications.then(response => {
            this.setState({
                listaAvisos: response.data.dados,
                paginasAvisos: response.data.paginacao.totalPaginas,
            });
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingAvisos: false
        }));
    }
   
    selecionaAviso(idAviso) {
        this.props.history.push(`/avisos/item/${idAviso}`);
    }

    render() {
        return (
            <div className="row notifications-list">
                <div className="col-12">
                    <div className="row no-gutters text-left">
                        <h2>Avisos - Lista de Avisos</h2>
                    </div>
                </div>
                <div className="col-12 text-center text-lg-left">
                    <p className="py-2 m-0">Clique no aviso para obter informações.</p>
                    <div className="card">
                        <div className="card-body p-0">
                            <ReactTable
                                data={this.state.listaAvisos}
                                columns={this.columns}
                                onFetchData={this.refreshTableAvisos}
                                defaultPageSize={10}
                                pages={this.state.paginasAvisos}
                                page={this.state.pagina}
                                manual
                                pageSize={this.state.limite}
                                loading={this.state.isLoadingAvisos}
                                className="-striped -highlight"
                                headerClassName="ebs-table-header"
                                previousText='Anterior'
                                nextText='Próximo'
                                loadingText='Carregando...'
                                noDataText='Nenhum aviso encontrado.'
                                pageText='Página'
                                ofText='de'
                                rowsText='linhas'
                                getTdProps={(state, rowInfo, column, instance) => {
                                    return {
                                        onClick: (e, handleOriginal) => {
                                            if (rowInfo) {
                                                 this.selecionaAviso(rowInfo.original.idAviso)
                                            }
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div>

        )
    }
}

export default NotificationsList;